import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./InviteCustomerForm";
import {cancelInviteCustomer} from "../../actions/OnboardingApiActions";
import {Map} from "immutable";
import {validatePresence} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "password");
  return errors.toJS();
}

class InviteCustomerFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("customerId", this.props.customerId);
    return this.props.createCustomerAuthInvite(updatedValues.toJS())
      .then((response) => {
        if (response.data.createCustomerAuthInvite.errors.length <= 0) {
          this.props.cancelInviteCustomer();
        } else {
          let errors = createValidationErrors(response.data.createCustomerAuthInvite.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelInviteCustomer();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const CHANGE_MIGRATION_PASSWORD = gql`
  mutation createCustomerAuthInvite($data: CustomerAuthInviteInput!) {
    createCustomerAuthInvite(input: $data) {
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(CHANGE_MIGRATION_PASSWORD, {
    props: ({ mutate }) => ({
      createCustomerAuthInvite: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

export default connect(null, {cancelInviteCustomer})(withQueries(InviteCustomerFormContainer));